import { createSlice } from "@reduxjs/toolkit";

const addNewChildSlice = createSlice({
    name: "addNewChildSetup",
    initialState: {
        newKidData: null,
        kidDeviceQRCode: null,
        addKidStatus: ''
    },
    reducers: {
      setNewKidData: (state, action) => {
        state.newKidData = action?.payload
      },
      setAddKidStatus: (state, action) => {
        state.addKidStatus = action?.payload
      },
      setKidDeviceData: (state, action) => {
        state.kidDeviceQRCode = action?.payload
      },
      removeNewKidData: (state, action) => {
        state.newKidData = null
        state.kidDeviceQRCode = null
        state.addKidStatus = ''
      },
      clearAddNewChild: (state, action) => {
        state.newKidData = null
        state.kidDeviceQRCode = null
        state.addKidStatus = ''
      }
    }
  });


// this is for dispatch
export const { setNewKidData, removeNewKidData, setAddKidStatus, setKidDeviceData, clearAddNewChild } = addNewChildSlice.actions;

// this is for configureStore
export default addNewChildSlice.reducer;